import makeRequest from './../../core/fetch';

export function loadList(page = 1) {
    return makeRequest(`/push?page=${page}`, `GET`)
}

export function addItem(data = {}) {
    return makeRequest(`/push`, `POST`, data);
}
